import { Button, Signage } from '@kcd/design-system';

import { useGoHome, usePushWithQuery } from '~/hooks/url';

import { DataErrorImg } from '~/assets/img/common';

interface Props {
  title?: string;
  description?: string;
  buttonText?: string;
  href?: string;
}
const EmptyCart = ({ title, description, buttonText, href }: Props) => {
  const goHome = useGoHome('push');
  const nextPush = usePushWithQuery();

  const onClickButton = () => {
    if (href) {
      void nextPush(href);
    } else {
      goHome();
    }
  };

  return (
    <Signage
      className="pt-128"
      title={title || '장바구니에 담긴 상품이 없습니다'}
      image={() => (
        <img src={DataErrorImg.src} className="size-64" alt="error guide" />
      )}
      description={description || '상품을 장바구니에 담아보세요!'}
      action={
        <Button size="sm" variant="outline" onClick={onClickButton}>
          {buttonText || '캐시노트마켓 홈으로 이동'}
        </Button>
      }
    />
  );
};

export default EmptyCart;
